import styled from '@emotion/styled'
import { IconFACheck, IconFATimes } from 'mailup-web-components'

const iconStyle = `font-size: 14px;
width: 21px;
height: 21px;
border-radius: 50%;
font-size: 14px;
width: 21px;
height: 21px;
border-radius: 50%;

> svg {
  top: 50% !important;
  left: 50%;
  transform: translate(-50%, -50%);
}
`

export const IconOk = styled(IconFACheck)`
  ${iconStyle}
  color: #56b113;
  background-color: #c4e8ae;
  > svg {
    width: 12px !important;
    height: 9px !important;
  }
`

export const IconSpam = styled(IconFATimes)`
  ${iconStyle}
  color: #fd4541;
  background-color: #ffafa7;
  > svg {
    width: 8px !important;
    height: 8px !important;
  }
`
